import { gql } from "@apollo/client";

/**
 * Query to get the current deployed client version.
 */
export const CURRENT_CLIENT_VERSION_QUERY = gql`
    query CurrentClientVersion {
        currentClientVersion {
            version
            deployedAt
        }
    }
`;

/**
 * Subscription for real-time client version updates.
 * This is broadcast when a new frontend version is deployed.
 */
export const CLIENT_VERSION_SUBSCRIPTION = gql`
    subscription OnClientVersionUpdated {
        clientVersionUpdated {
            version
            force
            message
        }
    }
`;
